import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/iPhone_my_number_card.svg")